import React from 'react';
import styles from './Error.module.scss';
import {
  Button,
  Content,
  FontAwesomeProIcon,
  Heading,
} from '@wienenergiegithub/ui-next';
import classNames from 'classnames';

// @TODO: Will be removed and replaced in all instances by AvailabilityError with upcoming ticket KITT3-3690
const Error = ({ onNewCheck, title = null, content = null, type }) => (
  <div className={styles.container} data-purpose="fernwaerme-error">
    <div className={classNames(styles.icon, styles.red)}>
      <FontAwesomeProIcon icon="circle-exclamation" size="lg" />
    </div>
    <Heading align="center" as="p" size="h5">
      {title || 'Es ist ein Fehler aufgetreten!'}
    </Heading>
    <Content align="center" size="lg" withParser>
      {content || 'Bitte versuchen Sie es später noch einmal.'}
    </Content>
    {type !== 'general' ? (
      <Button
        id="error-fernwaerme-weitere-addresse-pruefen"
        isElevated
        onClick={onNewCheck}
        theme="primary"
      >
        Weitere Adresse prüfen
      </Button>
    ) : (
      ''
    )}
  </div>
);

export default Error;
